// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Search Bar
*/

.header .search-bar {
  min-width: 360px;
  padding: 0 20px;
}

@media (max-width: 1199px) {
  .header .search-bar {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    padding: 20px;
    box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);
    background: white;
    z-index: 9999;
    transition: 0.3s;
    visibility: hidden;
    opacity: 0;
  }

  .header .search-bar-show {
    top: 60pz;
    visibility: visible;
    opacity: 1;
  }
}

.header .search-form {
  width: 100%;
}

.header .search-form input {
  border: 0;
  font-size: 14px;
  color: #012970;
  border: 1px solid rgba(1, 41, 112, 0.2);
  padding: 7px 38px 7px 8px;
  border-radius: 3px;
  transition: 0.3s;
  width: 100%;
}

.header .search-form input:focus,
.header .search-form input:hover {
  outline: none;
  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);
  border: 1px solid rgba(1, 41, 112, 0.3);
}

.header .search-form button {
  border: 0;
  padding: 0;
  margin-left: -30px;
  background: none;
}

.header .search-form button i {
  color: #012970;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/searchBar.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,kDAAkD;IAClD,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/*\nSearch Bar\n*/\n\n.header .search-bar {\n  min-width: 360px;\n  padding: 0 20px;\n}\n\n@media (max-width: 1199px) {\n  .header .search-bar {\n    position: fixed;\n    top: 50px;\n    left: 0;\n    right: 0;\n    padding: 20px;\n    box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);\n    background: white;\n    z-index: 9999;\n    transition: 0.3s;\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  .header .search-bar-show {\n    top: 60pz;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.header .search-form {\n  width: 100%;\n}\n\n.header .search-form input {\n  border: 0;\n  font-size: 14px;\n  color: #012970;\n  border: 1px solid rgba(1, 41, 112, 0.2);\n  padding: 7px 38px 7px 8px;\n  border-radius: 3px;\n  transition: 0.3s;\n  width: 100%;\n}\n\n.header .search-form input:focus,\n.header .search-form input:hover {\n  outline: none;\n  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);\n  border: 1px solid rgba(1, 41, 112, 0.3);\n}\n\n.header .search-form button {\n  border: 0;\n  padding: 0;\n  margin-left: -30px;\n  background: none;\n}\n\n.header .search-form button i {\n  color: #012970;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
